<div bsModal
     #reminderEmail="bs-modal"
     id="reminderEmail"
     class="modal fade"
     (onShown)="onShown()"
     role="dialog"
     aria-labelledby="reminderEmail"
     aria-hidden="true"
     [config]="{backdrop: 'static'}">

    <div class="modal-dialog">

        <div #modalContent class="modal-content">
            <div class="modal-header text-center">
                <button type="button" class="close" (click)="close()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h2 class="modal-title text-center">Reminders</h2>
            </div>

            <div class="modal-body">
                <!--AG GRID Assessments-->
                <div class="displayNone">
                    <!-- <h5>Assessments</h5> -->

                    <p>{{'Do you want to ' + (sendRemindEmail ? 'disable': 'enable') + ' reminder emails?'}}</p>
                </div>
            </div>

            <div class="modal-footer text-right">
                <input (click)="onClickCancel()" type="button" class="btn btn-danger" name="close" value="Cancel" />
                <input (click)="onClickOkay()" type="button" class="btn btn-primary waves-effect" value="Yes" />
            </div>
        </div>
    </div>
</div>